module.exports = __webpack_public_path__ + "img/glogo216.aa303938.png";